import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=146432aa&scoped=true"
import script from "./LogList.vue?vue&type=script&lang=ts"
export * from "./LogList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146432aa",
  null
  
)

export default component.exports